import { $api } from "services/AxiosInstance";

export class AiService {

  /**
   * @param {Object} data
   * @param {String} data.prompt
   * @param {String} [data.model]
   * @param {Number} [data.maxTokens]

   * @returns {Promise<Object>}
   */

  static getAIResponse (data) {
    return $api.post("/api/admin/v1/openai/generate", data);
  }

}
